var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('a-row',[_c('apexchart',{attrs:{"height":"400px","type":"pie","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }